
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/content-switcher/content-switcher.component.js'
      import type { DdsChangeEvent } from '../../events/events'
      export type { DdsChangeEvent } from '../../events/events'

      const tagName = 'dap-ds-content-switcher'

      /**
 * `dap-ds-content-switcher`
 * @summary A content switcher is a set of two or more segments, each of which functions as a mutually exclusive button.
 * @element dap-ds-content-switcher
 * @title - Content switcher
 *
 * @slot - The content switcher items.
 *
 * @event {{ value: string, selected: boolean }} dds-change - Fired when the content switcher is changed.
 *
 * @csspart base - The main content switcher container.
 *
 * @cssproperty --dds-content-switcher-min-width - The minimum width of the content switcher (default: var(--dds-spacing-4000, 160px))
 * @cssproperty --dds-content-switcher-padding - The padding of the content switcher (default: var(--dds-spacing-100, 4px))
 * @cssproperty --dds-content-switcher-border-width - The border width of the content switcher (default: var(--dds-border-width-base))
 * @cssproperty --dds-content-switcher-border-color - The border color of the content switcher (default: var(--dds-border-neutral-transparent))
 * @cssproperty --dds-content-switcher-border-radius - The border radius of the content switcher (default: var(--dds-radius-rounded, 1000px))
 * @cssproperty --dds-content-switcher-background - The background color of the content switcher (default: var(--dds-transparent-black-subtle, rgb(0 0 0 / 5%)))
 * @cssproperty --dds-content-switcher-gap - The gap between content switcher items (default: var(--dds-spacing-100, 4px))
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsChange: 'dds-change' as EventName<DdsChangeEvent>
        },
        displayName: "DapDSContentSwitcher"
      })

      export default reactWrapper
    